import {
  Card,
  Tabs,
  TabsProps,
  Select,
  message,
} from "antd";
import { useEffect, useState } from "react";
import StudioSettingsCard from "../component/Cards/StudioSettingsCard";
import BucketDetailCard from "../component/Cards/BucketDetailCard";
import AppHeader from "../layouts/header";
import { studioApi } from "../api";

interface YoutubeAccount {
  _id: string;
  channel_title: string;
}

export default function Config() {
  const getActiveTab = () => {
    const params = new URLSearchParams(
      window.location.search
    );

    return params.get("tab") || "1";
  };

  const [youtubeAccounts, setYoutubeAccounts] =
    useState<YoutubeAccount[]>([]);

  const [selectedChannel, setSelectedChannel] =
    useState<string>();

  const [activeTab, setActiveTab] =
    useState(getActiveTab());

  const getYoutubeAccounts = async () => {
    try {
      const { data } = await studioApi.get(
        "/youtube"
      );

      setYoutubeAccounts(data || []);

      const savedChannel =
        localStorage.getItem(
          "selected_youtube_channel"
        );

      if (savedChannel) {
        setSelectedChannel(savedChannel);
      }
    } catch (error: any) {
      message.error(
        error?.response?.data?.message ||
          "Failed to fetch YouTube accounts"
      );
    }
  };

  useEffect(() => {
    getYoutubeAccounts();
  }, []);

  const handleSelectChannel = (
    value: string
  ) => {
    setSelectedChannel(value);

    localStorage.setItem(
      "selected_youtube_channel",
      value
    );

    const selected =
      youtubeAccounts.find(
        (item) => item._id === value
      );

    if (selected) {
      message.success(
        `${selected.channel_title} selected`
      );
    }
  };

  const handleTabChange = (
    key: string
  ) => {
    setActiveTab(key);

    const params = new URLSearchParams(
      window.location.search
    );

    params.set("tab", key);

    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${params.toString()}`
    );
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Cloud Bucket Configurations",
      children: <BucketDetailCard />,
    },
    {
      key: "2",
      label: "Studio Settings",
      children: <StudioSettingsCard />,
    },
   
  ];

  return (
    <div>
      <AppHeader />

      <Card
        title="Studio Configuration"
        type="inner"
      >
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          items={items}
          tabBarExtraContent={
            activeTab === "3" ? (
              <div className="w-[280px] pr-2">
                <Select
                  placeholder="Select YouTube Channel"
                  className="w-full"
                  value={selectedChannel}
                  onChange={
                    handleSelectChannel
                  }
                  options={youtubeAccounts.map(
                    (channel) => ({
                      label:
                        channel.channel_title,
                      value: channel._id,
                    })
                  )}
                />
              </div>
            ) : null
          }
        />
      </Card>
    </div>
  );
}